<div #drawerActionWrapper class="drawer-action-wrapper" [style.--vh]="(vh$ | async)">

  <div class="main-content">
    <header #header *ngIf="groupInfo?.length" class="header" [class.optionalTitle]="groupInfo?.title">
      <p *ngIf="groupInfo?.title" class="optional-title">{{ groupInfo?.title }}</p>
      <txtb-group-paginator
        class="paginator"
        [groupInfo]="groupInfo"
        (nextElement)="showModalIfDrawingsNotSaved($event)"
      ></txtb-group-paginator>
    </header>

    <div class="drawer-background" [ngStyle]="backgroundStyles" (touchstart)="onDrawingAreaTouchStart($event)"></div>

    <div
      *ngIf="zoomFeatureAvailable"
      appZoom
      [reset$]="resetZoom$"
      [disableZoom$]="zoomDisabled$"
      (zoomChange)="onZoomChange($event)"
      (dblclick)="$event.stopPropagation()"
      class="drawer-box"
      [style.--top-offset]="headerHeight$ | async"
      [style.--bottom-offset]="footerHeight$ | async"
      [class.lock-zoom]="(zoomDisabled$ | async) === true || (percentageZoom$ | async) === MAX_PERCENT"
      (touchstart)="onDrawingAreaTouchStart($event)">
      <ng-container *ngTemplateOutlet="zoomableContent"></ng-container>
    </div>

    <div
      *ngIf="!zoomFeatureAvailable"
      class="drawer-box"
      [style.--top-offset]="headerHeight$ | async"
      [style.--bottom-offset]="footerHeight$ | async"
      (touchstart)="onDrawingAreaTouchStart($event)">
      <ng-container *ngTemplateOutlet="zoomableContent"></ng-container>
    </div>

    <ng-template #zoomableContent>
      <gwo-textbook-drawer
        class="textbook-drawer"
        [isOffline]="!!(isReadonlyMode$ | async)"
        [isZoomed]="(isZoomed$ | async) === true"
        [footerHeight]="(footerHeight$ | async)!"
        [headerHeight]="(headerHeight$ | async)!"
        [style.opacity]="(visibility$ubject | async) ? 1 : 0"
        [vh]="vh$ | async"
      ></gwo-textbook-drawer>
      <section
        #actionContentWrapper
        class="action-content-wrapper"
        [style.--top-offset]="headerHeight$ | async"
        [style.--bottom-offset]="footerHeight$ | async"
        *ngIf="contentVisible"
      >
        <div
          class="action-background-content-wrapper"
          [ngClass]="contentWrapperBehaviour"
          [class.collapsed]="actionContentCollapsed"
          [class.scroll-disabled]="(drawingByPointerMove$ | async) === true || (isZoomed$ | async) === true"
        >
          <ng-content select="[main]"></ng-content>

          <div class="minimize-arrow-wrapper"
               id="drawer-minimize-icon-wrapper"
               *ngIf="minimizeArrowVisible && !actionContentCollapsed && !(tool$ | async) && !textToolActive">
            <txtb-icons
              id="drawer-minimize-arrow"
              class="minimize-arrow"
              type="minimizeArrow"
              (click)="toggleContentCollapse()"
            ></txtb-icons>
          </div>
          <txtb-icons
            id="drawer-maximize-arrow"
            *ngIf="minimizeArrowVisible && actionContentCollapsed && !(tool$ | async) && !textToolActive"
            class="minimize-arrow"
            type="minimizeArrow"
            (click)="toggleContentCollapse()"
          ></txtb-icons>
        </div>
        <txtb-drawer-texts
          [currentZoom$]="textbookActionsHandler.selectZoomPercentage$"
          [isActive$]="textToolActive$ubject.asObservable()"
          [isVisible$]="visibility$ubject.asObservable()"
          [isDisabled$]="isZoomed$"
          [textColor]="color$ubject | async"
          (isTextToolActive)="toggleTextToolActive($event)"
          (isActive)="toggleTextboxesActiveState($event)"
        ></txtb-drawer-texts>
      </section>
    </ng-template>


    <footer #footer class="bottom-ui">
      <button class="back-button"
              id="drawer-back-btn"
              (click)="showModalIfDrawingsNotSaved()">
        <txtb-icons type="backArrow" class="back-icon"></txtb-icons>
      </button>
      <p *ngIf="playerType === playerTypes.Textbooks" class="page-number">
        Strona {{ this.textbookActionsHandler.currentActionPageNumber$ | async }}
      </p>
      <section class="bottom-content">
        <ng-content select="[footer]"></ng-content>
      </section>
    </footer>
  </div>
  <section class="toolbox">
    <ul class="drawer-toolbox">
      <li class="tool pencil border-bottom-transparent">
        <button
          id="drawer-brush-tool-btn"
          type="button"
          class="pencil-tool"
          [disabled]="(isZoomed$ | async) === true"
          [class.cursorDefault]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
          (click)="toggleTool(toolName.Brush)"
        >
          <txtb-icons
            type="pencil"
            [fill]="
              (isReadonlyMode$ | async) || (isZoomed$ | async) === true
                ? disabledColor
                : (tool$ | async) === toolName.Brush
                ? activeColor
                : null
            "
          ></txtb-icons>
        </button>
      </li>

      <li class="tool eraser border-top-bottom-transparent">
        <txtb-drawer-eraser-tool
          id="drawer-eraser-tool"
          (toggleEraser)="toggleTool(toolName.Eraser)"
          (clearAll)="clear()"
          (click)="showPopupIfOffline()"
          [isOffline]="!!(isReadonlyMode$ | async)"
          [isZoomed]="(isZoomed$ | async) === true"
          [isCanvasDirty]="
            (textbookActionsHandler.isCanvasDirty$ | async) ||
            actionNotesService.currentNotes.length > 0
          "
          [disabledColor]="disabledColor"
          [clearCanvasColor]="clearCanvasColor"
          [tool$]="tool$uject"
          [class.cursorDefault]="isReadonlyMode$ | async"
          [activeColor]="activeColor"
          [activeFill]="
            (isReadonlyMode$ | async) || (isZoomed$ | async) === true
              ? disabledColor
              : (tool$ | async) === toolName.Eraser
              ? activeColor
              : null
          "
        ></txtb-drawer-eraser-tool>
      </li>

      <li class="tool figures border-top-bottom-transparent">
        <txtb-drawer-figures-tool
          id="drawer-figures-tool"
          (toolName)="toggleTool($event)"
          [activeColor]="activeColor"
          [class.cursorDefault]="!!(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
          [disabledColor]="disabledColor"
          [isOffline]="!!(isReadonlyMode$ | async)"
          [isZoomed]="(isZoomed$ | async) === true"
          [pickedTool$]="tool$"
          (click)="showPopupIfOffline()"
        ></txtb-drawer-figures-tool>
      </li>

      <li class="tool text border-top-bottom-transparent">
        <button
          type="button"
          [disabled]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
          [class.cursorDefault]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
        >
          <txtb-icons
            id="drawer-text-tool"
            type="text"
            class="text-tool"
            [fill]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true ? disabledColor : textToolActive ? activeColor : null"
            (click)="toggleTextTool()"
          ></txtb-icons>
        </button>
      </li>

      <li class="tool cog border-top-transparent">
        <button
          type="button"
          class="cog-tool"
          [disabled]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
          [class.cursorDefault]="(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
        >
          <txtb-drawer-settings
            id="drawer-settings"
            [activeColor]="activeColor"
            [disabledColor]="disabledColor"
            [isOffline]="!!(isReadonlyMode$ | async)"
            [isZoomed]="(isZoomed$ | async) === true"
            [color$]="color$ubject"
            [size$]="size$ubject"
            [transparency$]="transparency$ubject"
            (colorChange)="color($event)"
            (sizeChange)="size($event)"
            (click)="showPopupIfOffline()"
            (transparencyChange)="transparency($event)"
          ></txtb-drawer-settings>
        </button>
      </li>

      <li class="tool background border-transparent">
        <txtb-drawer-background-tool
          id="drawer-background-tool"
          [activeColor]="activeColor"
          [disabledColor]="disabledColor"
          (click)="showPopupIfOffline()"
          [isOffline]="!!(isReadonlyMode$ | async)"
          [isZoomed]="(isZoomed$ | async) === true"
          (backgroundStyle)="backgroundStyles = $event"
          [class.cursorDefault]="!!(isReadonlyMode$ | async) || (isZoomed$ | async) === true"
        ></txtb-drawer-background-tool>
      </li>

      <li class="tool visible border-transparent">
        <button
          type="button"
          id="drawer-visible-tool-btn"
          class="visible-tool"
          (click)="toggleVisibility()"
        >
          <txtb-icons
            [type]="(visibility$ubject | async) === false ? 'eye' : 'eyeDisabled'"
            [fill]="(visibility$ubject | async) === false ? activeColor : null"
          ></txtb-icons>
        </button>
      </li>

      <li class="tool cog border-transparent">
        <button
          id="drawer-save-btn"
          *ngIf="playerType === playerTypes.Textbooks && !editorPreviewMode"
          type="button"
          class="cog-tool"
          (click)="onSaveClick()"
          [class.isCanvasNotEdited]="(canvasEdited$ | async) === false"
        >
          <txtb-icons
            type="save"
            [fill]="
              (isReadonlyMode$ | async) || (isZoomed$ | async) === true
                ? disabledColor
                : (spinnerVisibility$ubject | async)
                ? activeColor
                : !isPremium
                ? basicColor
                : !(canvasEdited$ | async)
                ? clearCanvasColor
                : null
            "
          ></txtb-icons>
          <span *ngIf="spinnerVisibility$ubject | async" class="spinner"></span>
        </button>
      </li>
    </ul>
  </section>

  <swal
    id="drawer-alert"
    #drawingsNotSaved
    title="Uwaga!"
    html="Próbujesz zamknąć niezapisaną notatkę graficzną.<br>
    Jeśli chcesz ją zachować, wróć do widoku<br>notatek i kliknij w ikonę <i>zapisz</i>."
    confirmButtonText="Wyjdź bez zapisywania"
    cancelButtonText="Wróć do notatek"
    input="checkbox"
    inputPlaceholder="Nie pokazuj więcej tego komunikatu."
    [showCancelButton]="true"
    [showCloseButton]="true"
    [focusCancel]="true"
  >
  </swal>
</div>
